class service {
  // Change Testing Enviourment true => Server / false => Local
  isTest = true;

  // Constents
  seekapeek_local = "http://localhost:8080/api"; 
  // seekapeek_server = "https://api.thefactmagic.com";
  //  seekapeek_server="https://api.mazingbytes.com/api";
  // seekapeek_server="https://stgapi.thefactmagic.com";
  seekapeek_server=process.env.REACT_APP_API_URL;


  // for variables
  //  constUrl_server = '//thefactmagic.com';
  // constUrl_server='//cms.mazingbytes.com';
  //  constUrl_server='//stg.thefactmagic.com';
  //  constUrl_server='//localhost:3000';
  // constUrl_local = '//localhost:3000';
  constUrl_server=process.env.REACT_APP_SERVER;
  constUrl_local=process.env.REACT_APP_SERVER;

  // #assets path
  assetsPath_server=process.env.REACT_APP_ASSETSPATH;
  assetsPath_local=process.env.REACT_APP_ASSETSPATH;
  // Function for thefactmagic api's 
  getBaseUrl() {
    if (this.isTest === true) {
      return this.seekapeek_server;
    } else {
      return this.seekapeek_local;
    }
  }

  //
  getConstUrl() {
    if (this.isTest === true) {
      return this.constUrl_server;
    } else {
      return this.constUrl_local;
    }
  }

  getAssetsPath() {
    if (this.isTest === true) {
      return this.assetsPath_server;
    } else {
      return this.assetsPath_local;
    }
  }

}

export default new service ();
